<template lang="pug">
  v-card.mb-3

</template>

<script>
export default {
  props: ['extra'],
}
</script>
